import VoteEmote from 'cc/VoteEmote'
import { cn } from 'common/utils'

// TODO: DRY?
const moodClass = (effectiveVote) =>
  effectiveVote > 0 ? 'text-green-600' : effectiveVote < 0 ? 'text-red-600' : 'text-gray-500'

const VoteArrowWithBadge = ({ vote, text }) => (
  <div className={cn('relative', moodClass(vote))}>
    <div className="h-full w-full absolute inset-0 flex justify-center items-center z-10 text-xl">{text}</div>
    <div className="h-full w-full relative inset-0 flex justify-center items-center">
      <VoteEmote vote={vote} className="w-20" />
    </div>
  </div>
)

export default VoteArrowWithBadge
